<template>
  <div class="container my30 px15" v-if="deliveryTimeDays">
    <div class="row center-xs">
      <header class="col-md-12 delivery-wrapper">
        <h3 class="align-center cl-accent">
          {{ $t('Pickup schedule') }}
        </h3>
      </header>
    </div>
    <section class="delivery-days row center-xs">
      <div class="date col-xs-12">
        <ul class="date-picker-wrap center-xs nav-tabs mb15">
          <li class="date-picker-elem nav-item relative pb10" v-for="(deliveryTimeDay, day, index) in deliveryTimeDays" :key="index"
              :class="{ 'active': toActive(index) }"
              v-if="index <=2">
            <a class="no-underline" @click.prevent="setActive(index)">
              <span class="day bold">{{ getMoment(day) }}</span><br/>
              <span class="month h5">{{ getMonth(day) }}</span>
            </a>
            <span v-if="toActive(index)" class="corner"></span>
          </li>
        </ul>
      </div>
      <div class="tab-content col-xs-12 col-md-9">
        <div
                v-for="(deliveryTimeDay, day, index) in deliveryTimeDays"
                class="date-item tab-pane "
                :class="{ 'active show': toActive(index) }"
                :key="day"
                v-if="index <=2"

        >
          <div class="time-range">
            <div class="delivery-day time-range-item">
              <div class="range" v-for="(deliveryTimeRange, j) in deliveryTimeDay" :key="j">
                <div  class="spacing" :class="{
                  'active-green': deliveryTimeRange.status === 'open',
                  'close-yellow': deliveryTimeRange.status === 'closing'
                }">
                  {{ deliveryTimeRange.value }}
                </div>
                <span>
                  0 грн
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="row center-xs">
      <ul class="display-status">
        <li><span class="not-available-gray">{{ $t('Not available') }}</span></li>
        <li><span class="close-yellow">{{ $t('Closes') }}</span></li>
        <li><span class="active-green">{{ $t('Available') }}</span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { storedCartToken } from '@vue-storefront/core/modules/cart/helpers/cartTokenCookie'
import NoSSR from 'vue-no-ssr'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      config: {
        perPageCustom: [[320, 1], [360, 1], [400, 2], [576, 2], [768, 3], [1024, 3]],
        paginationEnabled: false,
        mouseDrag: false
      },
      deliveryTimeDays: null,
      currentPage: 0,
      activeItem: 0,
      cartId: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentPartner: 'partners/getCurrentPartner',
      getCurrentLocation: 'locations/getActiveLocation',
      getShippingDetails: 'checkout/getShippingDetails'
    })
  },
  components: {
    'Carousel': () => import('vue-carousel').then(Slider => Slider.Carousel),
    'Slide': () => import('vue-carousel').then(Slider => Slider.Slide),
    'no-ssr': NoSSR
  },
  mounted () {
    this.$nextTick(() => {
      this.cartId = storedCartToken()
      let partnerCode = this.getCurrentPartner.code
      let locationCode = this.getCurrentLocation.code
      let shippingMethod = this.getShippingDetails.shippingMethod
      let cartId = this.cartId
      this.getDeliveryTime({
        partner_code: partnerCode,
        location_code: locationCode,
        shipping_method: shippingMethod,
        cartId: cartId
      })
        .then(response => {
          this.deliveryTimeDays = response
        });
    })
  },
  methods: {
    ...mapActions({
      getDeliveryTime: 'checkout/getDeliveryTime'
    }),
    setMuted (currentPage) {
      this.currentPage = currentPage
    },
    getMoment: function (index) {
      moment.locale('uk');
      return moment(index).format('D');
    },
    getMonth: function (index) {
      moment.locale('uk');
      return moment(index).format('MMMM');
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    toActive (menuItem) {
      return this.activeItem === menuItem
    }
  }
}
</script>
<style lang="scss" scoped>
.delivery-days{
  color: #303030;
}
.spacing {
  margin-right: 15px
}
.date-data{
  padding: 8px 0;
  text-align: center;
  width: 100%;
  border-bottom: 1px solid #ffffff;
  font-size: 18px;
  display: inline-block;
}
.delivery-day{
  height: 100%;
  padding: 0;
  border-radius: 15px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(239, 239, 239);
  border-image: initial;
  background-color: #f6f6f6;
  margin-bottom: 15px;

  @media (max-width: 555px) {
    margin-bottom: 0;
  }
}
.cl-accent {
  font-size: 30px;
}
.cl-accent {
  @media (max-width: 555px) {
    font-size: 28px;
  }
}
.range{
  padding: 10px 0;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  width: 100%;
}
.display-status{
  display: block;
  margin-top: 25px;
  margin-bottom: 0;
    padding-left: 0;

}
.display-status li{
  list-style: none;
  padding: 3px 10px;
  float: left;
  font-size: 14px;
}
.close-yellow{
  color: rgb(247, 154, 0);
}
.active-green{
  color: rgb(69, 183, 89);
}
.delivery-wrapper{
  padding-bottom: 15px;
}

.date-picker-elem.active a{
  color: rgb(255, 255, 255);
  background: #11bb2e;
  border: 1px solid #11bb2e;
}
.date-picker-elem a.underline:after, .date-picker-elem a:not(.no-underline):hover:after{
  height: 0;
}
.date-picker-elem a{
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  color: #11bb2e;
  cursor: pointer;
  padding: 15px 15px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #ebebeb;
}
.date-picker-elem{
  text-align: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: 8px;
}
.date-picker-wrap{
  display: flex;
  overflow: auto;
  padding-left: 0;
}
.tab-content>.tab-pane.active {
  display: block;
}
.tab-content>.tab-pane {
  display: none;
}
.corner {
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: #11bb2e transparent transparent transparent;
}
.bold{
  font-family: 'TTNorms Bold', sans-serif;
}
</style>
